import { render, staticRenderFns } from "./FrameworkAccess.vue?vue&type=template&id=52e8096a"
import script from "./FrameworkAccess.vue?vue&type=script&lang=js"
export * from "./FrameworkAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports